import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Page } from '../pagination';
import { PaginationService } from '../services/pagination.service';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit, OnChanges {

  @Input()
  items: any[] = [];

  @Input()
  pageItems: any[] = [];

  @Output()
  pageItemsChange = new EventEmitter<any[]>(true);

  @Input()
  page = 1;

  @Input()
  pageSize = 10;

  @Output()
  pageChange = new EventEmitter<number>();

  pages: Page[] = [{ value: 1, canClick: true }];
  pageSizeOptions = [5, 10, 20, 30, 40, 50];

  lastPage = 1;

  constructor(private paginationService: PaginationService) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.computePagesRanges();

    if (changes.items || changes.pageSize) {
      this.updateDisplayedItems();
    }
  }

  changeNumberOfItemsPerPage() {
    this.computePagesRanges();
    this.changePage(1);
  }

  computePagesRanges() {
    this.lastPage = this.items ? Math.ceil(this.items.length / this.pageSize) : 1;

    if (!this.items || this.items.length < this.pageSize) {
      this.lastPage = 1;
    } else {
      this.lastPage = Math.ceil(this.items.length / this.pageSize);
    }

    this.setPages();
  }

  changePage(page: number) {
    this.page = page;
    this.updateDisplayedItems();

    this.pageChange.emit(page);
  }

  updateDisplayedItems() {
    const start = (this.page - 1) * this.pageSize;
    const end   = this.page * this.pageSize;

    if (this.page >= 1 && this.page <= this.lastPage) {
      this.pageItems = this.items.slice(start, end);
      this.pageItemsChange.emit(this.pageItems);
    }
  }

  previousPage() {
    if (this.page <= 1) {
      return;
    }

    this.changePage(this.page - 1);
  }

  nextPage() {
    if (this.page >= this.lastPage) {
      return;
    }

    this.changePage(this.page + 1);
  }

  setPages() {
    this.pages = this.paginationService.getPages(this.page, this.lastPage);
  }

}
